import { render, staticRenderFns } from "./card_produzenten_count.vue?vue&type=template&id=64fe6ab1&scoped=true"
import script from "./card_produzenten_count.vue?vue&type=script&lang=js"
export * from "./card_produzenten_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe6ab1",
  null
  
)

export default component.exports